import * as React from "react";

type Props = {
  field: string;
  type: "Tel" | "Mob" | "Email";
};

export const FieldPhoneOrMail: React.FC<Props> = ({ field, type }) => {
  return (
    <>
      <span className="text-primary me-1">{type}</span>
      <span className="text-secondary">{field}</span>
    </>
  );
};
